if (!customElements.get('pf-appointment-form')) {
  customElements.define('pf-appointment-form', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.date = this.querySelector('[data-date]');
      if (!this.date) return;
      this.slots = [...this.querySelectorAll('[data-slot]')];
      this.showroom = this.querySelector('[data-showroom]');
      this.abort?.abort();
      clearInterval(this.timer);
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.form.addEventListener('input', () => this.update(), options);
      this.form.addEventListener('change', () => this.update(), options);
      this.form.addEventListener('submit', (event) => {
        this.update();
        if (!this.form.reportValidity()) event.preventDefault();
      }, options);
      this.timer = setInterval(() => this.update(), 30000);
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); clearInterval(this.timer); }
    update() {
      const zone = this.showroom.selectedOptions[0]?.dataset.timezone || 'Australia/Melbourne';
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {
        timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date()).map(({ type, value }) => [type, value]));
      const today = `${parts.year}-${parts.month}-${parts.day}`;
      const now = `${parts.hour}:${parts.minute}`;
      this.date.min = today;
      const pastDate = this.date.value && this.date.value < today;
      const ready = !!this.showroom.value && !!this.date.value && !pastDate;
      let remaining = 0;
      for (const slot of this.slots) {
        slot.disabled = !ready || (this.date.value === today && slot.value <= now);
        if (slot.disabled) slot.checked = false;
        else remaining++;
      }
      this.date.setCustomValidity(pastDate ? this.dataset.pastDate : ready && !remaining ? this.dataset.noTimes : '');
      this.querySelector('[data-slot-status]').textContent = !ready
        ? this.dataset.chooseDate
        : remaining ? this.dataset.selectTime
          : this.dataset.noneToday;
      this.querySelector('[data-timezone-value]').value = zone;
      this.querySelector('[data-timezone-note]').textContent = this.dataset.timezone.replace('__CITY__', zone.replace('Australia/', ''));
    }
  });
}
